module.exports = __webpack_public_path__ + "static/img/sql_icon.beec47e1.png";